module.exports = __webpack_public_path__ + "static/media/3.1.06b2dd39.png";